import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ticket from "../../assets/images/icons/ticket-compact-w.svg";
const FixedBtn = ({ t, lang }) => {
  const [isTicketBtnVisible, setTicketBtnVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  let flow = 823770;
  if (location.pathname.includes("elegant")) flow = 1012190;
  if (location.pathname.includes("historical")) flow = 1185435;

  useEffect(() => {
    window.addEventListener("scroll", (e) => {
      if (window.scrollY >= 1) setTicketBtnVisible(true);
      else setTicketBtnVisible(false);
    });
    return () =>
      window.removeEventListener("scroll", (e) => {
        if (window.scrollY >= 1) setTicketBtnVisible(true);
        else setTicketBtnVisible(false);
      });
  }, []);
  const loadScript = () => {
    let options = {
      shortname: "dunacruises",
      flow: flow,
      language: lang,
      view: "all-availability",
    };
    if (location.pathname.includes("tuzijatek")) {
      flow = 1230870;
      options = {
        shortname: "dunacruises",
        flow: flow,
        language: lang,
      };
    }

    if (window.FH) return window.FH.open(options);
    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    script.src = "https://fareharbor.com/embeds/api/v1/?autolightframe=yes";
    script.setAttribute("defer", true);
    head.append(script);
    setLoading(true);
    checkScript();
  };
  const checkScript = () => {
    let options = {
      shortname: "dunacruises",
      flow: flow,
      language: lang,
      view: "all-availability",
    };
    if (location.pathname.includes("tuzijatek")) {
      flow = 1230870;
      options = {
        shortname: "dunacruises",
        flow: flow,
        language: lang,
      };
    }

    if (window.FH) {
      setLoading(false);
      window.FH.open(options);
      return;
    }

    setTimeout(checkScript, 300);
  };
  if (location.pathname.includes("sights")) return null;
  if (location.pathname.includes("drinks")) return null;
  return (
    <div
      className={`fixed-btn-wrap-new ${isTicketBtnVisible ? "" : "hidden"} ${
        location.pathname.includes("tuzijatek") ? "aug20" : ""
      } ${location.pathname.includes("5ker") ? "hidden" : ""}`}>
      <div className="btn-wrap">
        <a
          id={`clickto-floating-bn-btn`}
          className="btn ticket-btn"
          onClick={(e) => {
            e.preventDefault();
            loadScript();
            window.fathom && window.fathom.trackEvent(`button click: ${e.target.id}`);
          }}
          // href={`https://fareharbor.com/embeds/book/dunacruises/items/?full-items=yes&flow=${flow}&view=all-availability`}
        >
          <img className="ticket-img" src={ticket} alt="" />
          <span className="btn__text">{t("main1.schedule.book")}</span>
        </a>
      </div>
    </div>
  );
};
export default FixedBtn;
